import { ApiResponse, GetParams, Pagination } from '@uservoice/rest-utils';
import axios from 'axios';

export type Team = {
  id: number;
  subdomainId: number;
  name: string;
  createdAt: string;
  updatedAt: string;
}

export const getTeams = async (params: GetParams): Promise<[Team[], Pagination]> => {
  const { data } = await axios.get<ApiResponse<'teams', Team>>('/api/account/teams', { params });
  return [data.teams, data.pagination];
};
